import React from 'react';
import './Pending.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

interface PendingProps {
  count: number;
  isActive?: boolean;
}

const Pending: React.FC<PendingProps> = ({ count, isActive = false }) => {
  return (
    <div className={`table-task-pending-container ${isActive ? 'active' : ''}`}>
      <span className="data-bar-icon pending">
        <FontAwesomeIcon icon={faClock} />
      </span>
      <span className="table-task-pending-label">Pending</span>
      <span className="table-task-pending-count">{count}</span>
    </div>
  );
};

export default Pending;
